// Need to use the React-specific entry point to import createApi
import {createApi, fetchBaseQuery} from '@reduxjs/toolkit/query/react'
import {buildBody} from './queryHelper'

// Courses API
export const coursesApi = createApi({
    reducerPath: 'coursesApi',
    baseQuery: fetchBaseQuery({baseUrl: urls.ajax}),
    endpoints: (builder) => ({

        // Fetch a course section (future, past, current, notes)
        getCoursesSection: builder.query({
            query({templateId, sections}) {
                return {
                    url: urls.ajax,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: 'POST',
                    body: buildBody({
                        action: 'fetch_course_details_sections_data',
                        templateId: templateId,
                        sections: sections
                    })
                }

            }
        }),

        // get the future course instances details, this happens when the accordion is expanded
        getFutureCoursesInstanceDetails: builder.query({
            query({courseRecordId, instanceId}) {
                return {
                    url: urls.ajax,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: 'POST',
                    body: buildBody({
                        action: 'fetch_course_instance_details_data',
                        templateId: courseRecordId,
                        instanceId: instanceId
                    })
                }

            }
        }),

        // Fetch online course instance details
        getOnlineCourseInstance: builder.query({
            query(templateId) {
                return {
                    url: urls.ajax,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: 'POST',
                    body: buildBody({
                        action: 'fetch_online_course_instance_details_data',
                        templateId: templateId,
                    })
                }

            }
        }),

        // Fetch online course instance details
        registerOnlineCourse: builder.query({
            query: ({onlineCourseWPPostId, productPermalinkOverride}) => {
                return {
                    url: urls.ajax,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: 'POST',
                    body: buildBody({
                        action: 'add_online_course_product_to_cart',
                        courseProductId: onlineCourseWPPostId,
                        productPermalinkOverride: productPermalinkOverride ? productPermalinkOverride : ''
                    })
                }

            },
        }),

        // Fetch online course instance details
        refreshCourseData: builder.query({
            query: () => {
                return {
                    url: urls.ajax,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: 'POST',
                    body: buildBody({
                        action: 'refresh_course_data',
                    })
                }

            },
        }),

        /**
         * A query function that fetches pathway availability for the provided template IDs.
         *
         * @function
         * @name getPathwayAvailability
         * @param {Object} builder - The builder object for constructing the query.
         * @returns {Object} A query configuration object including URL, headers, method, and request body.
         */
        getPathwayAvailability: builder.query({
            query(templateIds) {
                return {
                    url: urls.ajax,
                    headers: {
                        'Content-Type': 'application/x-www-form-urlencoded'
                    },
                    method: 'POST',
                    body: buildBody({
                        action: 'fetch_pathway_availability',
                        templateIds: templateIds.join(','),
                    })
                }
            }
        }),

    }),
})

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
    useGetCoursesSectionQuery,
    useLazyGetCoursesSectionQuery,
    useLazyRefreshCourseDataQuery,
    useGetFutureCoursesInstanceDetailsQuery,
    useLazyGetOnlineCourseInstanceQuery,
    useGetOnlineCourseInstanceQuery,
    useLazyRegisterOnlineCourseQuery,
    useGetPathwayAvailabilityQuery,
} = coursesApi
